export default "__VITE_IMAGE_ASSET__3d422826__";